import React, { useEffect, useRef } from 'react'

const SkeletonLoader: React.FC<{
  rows?: number
  columns?: number
  pagination?: boolean
}> = ({ rows = 5, columns = 3, pagination = false }) => {
  const generateColumnWidths = (cols: number) => {
    const widths = Array.from({ length: cols }).map(
      () => Math.floor(Math.random() * 40) + 30
    )
    const total = widths.reduce((acc, width) => acc + width, 0)
    return widths.map((width) => `${(width / total) * 100}%`)
  }

  const columnWidthsRef = useRef<string[]>([])

  useEffect(() => {
    columnWidthsRef.current = generateColumnWidths(columns)
  }, [columns])

  return (
    <div className="mx-auto w-full p-4">
      <div className="overflow-x-auto bg-accent-0">
        <table className="table-auto w-full">
          <thead>
            <tr className="animate-pulse bg-accent-75 py-3">
              {Array.from({ length: columns }).map((_, colIndex) => (
                <th
                  key={`${columns}-${colIndex}`}
                  className="px-4 py-4"
                  style={{ width: columnWidthsRef.current[colIndex] }}
                >
                  <div className="h-4 bg-accent-200 rounded w-full p-2"></div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <tr key={`${rowIndex}-${rows}`} className="animate-pulse">
                {Array.from({ length: columns }).map((_, colIndex) => (
                  <td
                    key={`${rowIndex}-${colIndex}`}
                    className="px-4 py-3"
                    style={{ width: columnWidthsRef.current[colIndex] }}
                  >
                    <div className="h-4 bg-accent-200 rounded w-full p-1"></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {pagination && (
        <div className="bg-accent-75 flex gap-2 items-center justify-center h-10">
          <div className="h-8 w-8 rounded bg-accent-100"></div>
          <div className="h-8 w-8 rounded bg-accent-100"></div>
          <div className="h-8 w-8 rounded bg-accent-100"></div>
          <div className="h-8 w-8 rounded bg-accent-100"></div>
          <div className="h-8 w-8 rounded bg-accent-100"></div>
          <div className="h-4 w-10 rounded bg-accent-100"></div>
          <div className="h-5 w-12 rounded bg-accent-100"></div>
        </div>
      )}
    </div>
  )
}

export default SkeletonLoader
